import { registerIcon } from "@ui5/webcomponents-base/dist/SVGIconRegistry.js";

const name = "edit";
const pathData = "M475 104q5 7 5 12 0 6-5 11L150 453q-4 4-8 4L32 480l22-110q0-5 4-9L384 36q4-4 11-4t11 4zm-121 99l-46-45L84 381l46 46zm87-88l-46-44-64 64 45 45z";
const ltr = false;
const collection = "SAP-icons";

registerIcon(name, { pathData, ltr, collection});

export default { pathData };